// extracted by mini-css-extract-plugin
export var header = "_fe-0";